(function(angular) {
    'use strict';
    class DeleteMedialist {
        constructor($translate, $mdDialog) {
            this.$translate = $translate;
            this.$mdDialog = $mdDialog;
        }

        $onInit() {
            this.modalTitle = this.getModalTitle();
            this.okText = this.$translate.instant('action-label__delete');
            this.cancelText = this.$translate.instant('action-label__cancel');
            this.checkboxLabel = this.$translate.instant('icm-web__delete-modal--confirmation-prompt-checkbox');
        }

        getModalTitle() {
            // probably the safest default is to ask if you want to delete selected contacts from the list
            let modalTextKey = 'icm-web__delete-modal--confirmation-prompt-plural';

            if(this.deleteFromAllLists) {
                modalTextKey = this.plural ? 'icm-web__delete-modal--confirmation-prompt-all-contacts' : 'icm-web__delete-modal--confirmation-prompt-all-contacts-single';
            } else {
                modalTextKey = this.plural ? 'icm-web__delete-modal--confirmation-prompt-plural' : 'icm-web__delete-modal--confirmation-prompt';
            }

            return this.$translate.instant(modalTextKey);
        }

        handleOk () {
            this.$mdDialog.hide(this.deleteAll);
        }

        handleCancel() {
            this.$mdDialog.cancel();
        }
    }

    angular.module('MW.ContactManager.DeleteMediaList', [
        'ngMaterial'
    ])
    .component('deleteMedialist', {
        bindings: {
            deleteAll: '<',
            showCheckbox: '<',
            plural: '<',
            deleteFromAllLists: '<'
        },
        controller: ['$translate', '$mdDialog', DeleteMedialist],
        template: `
        <mw-mini-modal-dialog layout="column" data="$ctrl.deleteAll" dialog-title="" ok="{{$ctrl.okText}}" cancel="{{$ctrl.cancelText}}" on-ok="$ctrl.handleOk($event)" on-cancel="$ctrl.handleCancel($event)">
            <mw-modal-content>
                <div layout="column">
                    <h2 class="md-title title">
                        {{$ctrl.modalTitle}}
                    </h2>
                    <md-checkbox ng-if="$ctrl.showCheckbox" class="md-primary body" ng-model="$ctrl.deleteAll" aria-label="$ctrl.checkboxLabel">
                        <span ng-bind-html="$ctrl.checkboxLabel"></span>
                    </md-checkbox>
                </div>
            </mw-modal-content>
        </mw-mini-modal-dialog>
        `
    });
})(window.angular);
